module.exports = __webpack_public_path__ + "img/jieqing.adf20eb7.png";